import { useRef } from 'react';
import { useSelector as useReduxSelector, EqualityFn } from 'react-redux';

import { useStateUpdateEnabled } from './StateUpdateEnabledContext';

export function useSelector<S = unknown, T = unknown>(
  selector: (state: S) => T,
  equalityFn?: EqualityFn<T> | { equalityFn?: EqualityFn<T> }
): T {
  const stateUpdateEnabled = useStateUpdateEnabled();

  const selectedRef = useRef<T>();

  const selected = useReduxSelector((state: S) => {
    if (stateUpdateEnabled || selectedRef.current === undefined) {
      const selected = selector(state);

      selectedRef.current = selected;
    }
    return selectedRef.current;
    // react-redux has two overloads (EqualityFn | UseSelectorOptions); our union doesn't match either
  }, equalityFn as EqualityFn<T>);

  // Code to debug what's changing
  // const lastSelectedRef = useRef<T>();
  // const lastSelectedValue = lastSelectedRef.current;
  // if (lastSelectedValue !== selected) {
  //   console.trace('selected changed', lastSelectedValue, selected);
  //   lastSelectedRef.current = selected;
  // }
  // to check if the selector is returning similiar object with different reference.
  // if (lastSelectedValue !== selected && isEqual(lastSelectedValue, selected)) {
  //   console.trace('selected changed but similar', lastSelectedValue, selected);
  //   lastSelectedRef.current = selected;
  // }

  return selected;
}
